import fetchUserData from "../data/fetchUserData";
import store from "store";

export default async function getCachedUserData($config) {
  const userData = store.get("userData");
  if (userData?.userType) {
    return userData;
  }
  const newUserData = await fetchUserData($config);
  store.set("userData", newUserData);
  return newUserData;
}
